// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_INDEX_CATEGORY_DESCRIPTION_BABY = "Najv\u00e4\u010d\u0161\u00ed v\u00fdber, kvalitn\u00fd detsk\u00fd baz\u00e1r. Lacn\u00e9 aj kvalitn\u00e9. Iba mami\u010dky mami\u010dk\u00e1m.";
export const BAZAAR_INDEX_DESCRIPTION_BABY = "Kvalitn\u00fd detsk\u00fd baz\u00e1r! Oble\u010denie pre deti, top\u00e1nky, ko\u010d\u00edky, hra\u010dky ... Lacn\u00e9 aj kvalitn\u00e9. Iba mami\u010dky mami\u010dk\u00e1m.";
export const BAZAAR_SEO_BABY = "Baz\u00e1r";
export const BZ2_ADD_PRODUCT = "Pridaj inzer\u00e1t";
export const CONFIRM = "Potvr\u010f";
export const PAGE = "Strana";
